export default __webpack_public_path__ + "e8b19e53b55fcaa7b3a92ff634978ea2.svg";